import { TriangleAlert } from 'lucide-react';

export function FinanceWarning({ children }: { children: React.ReactNode }) {
    return (
        <div className="alert alert-warning">
            <TriangleAlert aria-hidden />
            <span>{children}</span>
        </div>
    );
}

export function MissingCostWarning({ missingCost }: { missingCost?: { movements: number; items: number } }) {
    if (!missingCost?.movements) return null;

    return (
        <FinanceWarning>
            {missingCost.items === 1 ? '1 item de estoque foi baixado' : `${missingCost.items} itens de estoque foram baixados`}{' '}
            sem preço de custo neste período, então os custos estão menores e a margem maior do que a real. Preencher o custo agora
            vale só para as próximas baixas.
        </FinanceWarning>
    );
}

export function PendingPostingsWarning({ count }: { count?: number }) {
    if (!count) return null;

    return (
        <FinanceWarning>
            {count === 1 ? '1 lançamento ainda não foi gravado' : `${count} lançamentos ainda não foram gravados`} por uma falha temporária,
            então os valores podem estar incompletos. O sistema tenta de novo automaticamente.
        </FinanceWarning>
    );
}
